import {
    FETCH_ECG_RECORDING_DETAILS_START,
    FETCH_ECG_RECORDING_DETAILS_SUCCESS,
    FETCH_ECG_RECORDING_DETAILS_FAIL,
    FETCH_ECG_RELATIVE_RECORDINGS_START,
    FETCH_ECG_RELATIVE_RECORDINGS_SUCCESS,
    FETCH_ECG_RELATIVE_RECORDINGS_FAIL,
    DELETE_ECG_RECORDING_START,
    DELETE_ECG_RECORDING_SUCCESS,
    DELETE_ECG_RECORDING_FAIL,
    FETCH_ECG_VIDEO_TUTORIAL_START,
    FETCH_ECG_VIDEO_TUTORIAL_SUCCESS,
    FETCH_ECG_VIDEO_TUTORIAL_FAIL
} from 'actions/ActionTypes';

const INITIAL_STATE = {
    ecgRecordings: null,
    ecgRecordingDetailsFetching: false,
    ecgRecordingDetailsSuccess: false,
    ecgRecordingDetailsFail: false,
    ecgRecordingDetailsErrorType: null,

    ecgRelativeRecordingsFetching: false,
    ecgRelativeRecordingsSuccess: false,
    ecgRelativeRecordingsFail: false,

    ecgRecordingDeleting: false,
    ecgRecordingDeleteSuccess: false,
    ecgRecordingDeleteFail: false,

    ecgVideoTutorial: null,
    ecgVideoTutorialFetching: false,
    ecgVideoTutorialSuccess: false,
    ecgVideoTutorialFail: false
};

const ecgRecordingDetailsFetching = (state) => ({
    ...state,
    ecgRecordingDetailsFetching: true,
    ecgRecordingDetailsErrorType: null
});

const ecgRecordingDetailsFetchFinished = (isSuccess) => (state, action) => {
    const { summary, errorType } = action.data;

    if (!summary && errorType) {
        return {
            ...state.ecgRecordings,
            ecgRecordingDetailsFetching: false,
            ecgRecordingDetailsFail: true,
            ecgRecordingDetailsErrorType: errorType
        };
    }

    const ecgRecordings = {
        ...state.ecgRecordings
    };

    if (!ecgRecordings[summary.detailId]) {
        ecgRecordings[summary.detailId] = {};
    }

    ecgRecordings[summary.detailId] = isSuccess ? action.data : null;

    return {
        ...state,
        ecgRecordings,
        ecgRecordingDetailsFetching: false,
        ecgRecordingDetailsSuccess: isSuccess,
        ecgRecordingDetailsFail: !isSuccess,
        ecgRecordingDetailsErrorType: !isSuccess && errorType ? errorType : null
    };
};

const ecgRelativeRecordingsFetching = (state) => ({
    ...state,
    ecgRelativeRecordingsFetching: true
});

const ecgRelativeRecordingsFetchFinished = (isSuccess) => (state, action) => {
    const { detailId } = action.data;

    const ecgRecordings = {
        ...state.ecgRecordings
    };

    if (!ecgRecordings[detailId]) {
        ecgRecordings[detailId] = {};
    }

    ecgRecordings[detailId] = isSuccess
        ? {
              ...ecgRecordings[detailId],
              relativeRecordings: action.data.relativeRecordings
          }
        : ecgRecordings[detailId];

    return {
        ...state,
        ecgRecordings,
        ecgRelativeRecordingsFetching: false,
        ecgRelativeRecordingsSuccess: isSuccess,
        ecgRelativeRecordingsFail: !isSuccess
    };
};

const ecgRecordingDeleting = (state, action) => {
    const ecgId = action.payload;

    if (!state.ecgRecordings || !state.ecgRecordings[ecgId]) {
        return state;
    }

    return {
        ...state,
        ecgRecordingDeleting: true
    };
};

const ecgRecordingDeleteFinished = (isSuccess) => (state, action) => {
    const ecgId = action.payload;
    if (!state.ecgRecordings || !state.ecgRecordings[ecgId]) {
        return state;
    }

    const ecgRecordings = { ...state.ecgRecordings };
    delete ecgRecordings[ecgId];

    return {
        ...state,
        ecgRecordings,
        ecgRecordingDeleting: false,
        ecgRecordingDeleteSuccess: isSuccess,
        ecgRecordingDeleteFail: !isSuccess
    };
};

const ecgVideoTutorialFetching = (state) => ({
    ...state,
    ecgVideoTutorialFetching: true
});

const ecgVideoTutorialFetchFinished = (isSuccess) => (state, action) => {
    const ecgVideoTutorial = action.data;

    return {
        ...state,
        ecgVideoTutorial,
        ecgVideoTutorialFetching: false,
        ecgVideoTutorialSuccess: isSuccess,
        ecgVideoTutorialFail: !isSuccess
    };
};

export const isEcgRecordingDetailsFetching = (state) => state.ecgRecordingDetails.ecgRecordingDetailsFetching;
export const isEcgRecordingDetailsSuccess = (state) => state.ecgRecordingDetails.ecgRecordingDetailsSuccess;
export const isEcgRecordingDetailsFail = (state) => state.ecgRecordingDetails.ecgRecordingDetailsFail;

export const getEcgRecordingDetails = (state, ecgId) =>
    state.ecgRecordingDetails && state.ecgRecordingDetails.ecgRecordings
        ? state.ecgRecordingDetails.ecgRecordings[ecgId]
        : null;
export const getEcgRecordingDetailsErrorType = (state) => state.ecgRecordingDetails.ecgRecordingDetailsErrorType;

export const isEcgRelativeRecordingsFetching = (state) => state.ecgRecordingDetails.ecgRelativeRecordingsFetching;
export const isEcgRelativeRecordingsSuccess = (state) => state.ecgRecordingDetails.ecgRelativeRecordingsSuccess;
export const isEcgRelativeRecordingsFail = (state) => state.ecgRecordingDetails.ecgRelativeRecordingsFail;

export const isEcgRecordingDeleting = (state) => state.ecgRecordingDetails.ecgRecordingDeleting;
export const isEcgRecordingDeleteSuccess = (state) => state.ecgRecordingDetails.ecgRecordingDeleteSuccess;
export const ecgRecordingDeleteFail = (state) => state.ecgRecordingDetails.ecgRecordingDeleteFail;

export const isEcgVideoTutorialFetching = (state) => state.ecgRecordingDetails.ecgVideoTutorialFetching;
export const isEcgVideoTutorialSuccess = (state) => state.ecgRecordingDetails.ecgVideoTutorialSuccess;
export const isEcgVideoTutorialFail = (state) => state.ecgRecordingDetails.ecgVideoTutorialFail;

export const getEcgVideoTutorial = (state) =>
    state.ecgRecordingDetails && state.ecgRecordingDetails.ecgVideoTutorial
        ? state.ecgRecordingDetails.ecgVideoTutorial
        : null;

const handlers = {
    [FETCH_ECG_RECORDING_DETAILS_START]: ecgRecordingDetailsFetching,
    [FETCH_ECG_RECORDING_DETAILS_SUCCESS]: ecgRecordingDetailsFetchFinished(true),
    [FETCH_ECG_RECORDING_DETAILS_FAIL]: ecgRecordingDetailsFetchFinished(false),

    [FETCH_ECG_RELATIVE_RECORDINGS_START]: ecgRelativeRecordingsFetching,
    [FETCH_ECG_RELATIVE_RECORDINGS_SUCCESS]: ecgRelativeRecordingsFetchFinished(true),
    [FETCH_ECG_RELATIVE_RECORDINGS_FAIL]: ecgRelativeRecordingsFetchFinished(false),

    [DELETE_ECG_RECORDING_START]: ecgRecordingDeleting,
    [DELETE_ECG_RECORDING_SUCCESS]: ecgRecordingDeleteFinished(true),
    [DELETE_ECG_RECORDING_FAIL]: ecgRecordingDeleteFinished(false),

    [FETCH_ECG_VIDEO_TUTORIAL_START]: ecgVideoTutorialFetching,
    [FETCH_ECG_VIDEO_TUTORIAL_SUCCESS]: ecgVideoTutorialFetchFinished(true),
    [FETCH_ECG_VIDEO_TUTORIAL_FAIL]: ecgVideoTutorialFetchFinished(false)
};

export default function ecgRecordingDetails(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
